import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';

import TooltipOnCursor from 'components/Shared/TooltipOnCursor';

import LigneEditee from './LigneEditee';

import { AnomalieType } from '../../../constants';
import { KitType } from '../../../constants';

const styles = theme => ({
    row: {
        flexBasis: '100%'
    },
    rootTable: {
        width: '100%',
        //height: '200px',
        overflowX: 'auto',
        overFlowY: 'auto'
    },
    buttonBar: {
        flexBasis: '100%',
        paddingLeft: 10
    },
    buttonLeft: {
        width: '20%',
        float: 'left'
    },
    buttonRight: {
        float: 'right'
    },
    table: {
        tableLayout: 'fixed',
        width: '100%'
    },
    colNumeroLigne: { width: 110 },
    colNumeroLigneBody: { width: 110, textAlign: 'right', paddingRight: '30px !important' },
    colCodeArticle: { width: 100 },
    colQuantite: { width: 110, textAlign: 'right' },
    colPrix: { width: 110, textAlign: 'right' },
    colMarqueExclusive: { width: 90 },
    colFournisseur: { width: 160 },
    wrapCell: {
        whiteSpace: 'normal',
        wordBreak: 'break-word'
    },
    ellipsisCell: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    rowAnomalie: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white
    },
    rowStriped: {

        // https://stripesgenerator.com/stripe/4974

        backgroundImage: "linear-gradient(135deg, #f5f5f5 25%, #eff0eb 25%, #eff0eb 50%, #f5f5f5 50%, #f5f5f5 75%, #eff0eb 75%, #eff0eb 100%);",
        backgroundSize: "56.57px 56.57px;"
    },
    rowEditing: {
        flexBasis: '100%',
        padding: 10,
        display: 'flex',
        alignItems: 'flex-end',
    },
    label: {
        display: 'inline',
        paddingRight: 10
    }
});

const retourExclusionErreurMessages = [
    {
        exclusionFlag: 1,
        message: 'Article exclu des retours (pièce gestion ligne)'
    },
    {
        exclusionFlag: 2,
        message: 'Article exclu des retours (périssable)'
    },
    {
        exclusionFlag: 4,
        message: 'Article exclu des retours (administré)'
    },
    {
        exclusionFlag: 8,
        message: 'Seul le retour kit au complet est possible.'
    },
    {
        exclusionFlag: 16,
        message: "Au moins un des articles composant du kit est exclu des retours, le retour n'est pas autorisé sur le code composé."
    },
    {
        exclusionFlag: 32,
        message: "Article exclu des retours (code gestion)"
    }
]

const lstTypeAnomalieAfficherDescriptif = [
    AnomalieType.ErreurProduit,
    AnomalieType.DefautProduitManqueAccessoire,
    AnomalieType.DefautProduitCasse,
    AnomalieType.DefautProduitAspectDeballage,
    AnomalieType.DefautProduitPremiereUtilisation,
    AnomalieType.DefautApresFonctionnement
];

const getLibelleDescriptif = (typeAnomalie) => {
    switch (typeAnomalie) {
        case AnomalieType.DefautProduitManqueAccessoire:
            return "Description de l'accessoire manquant";
        case AnomalieType.DefautProduitAspectDeballage:
            return "Description de l'élément défectueux";
        case AnomalieType.DefautProduitPremiereUtilisation:
            return "Défaut constaté";
        case AnomalieType.ErreurProduit:
            return "Description du produit reçu";
        default:
            return "Description de l'anomalie";
    }
}

const getLibelleQuantiteAnomalie = (typeAnomalie) => {
    switch (typeAnomalie) {
        case AnomalieType.QuantiteArticleIncorrecte:
            return "Quantité réellement reçue";
        case AnomalieType.ErreurProduit:
            return "Quantité reçue à la place";
        case AnomalieType.DefautProduitManqueAccessoire:
            return "Quantité manquante";
        case AnomalieType.DefautProduitAspectDeballage:
        case AnomalieType.DefautProduitPremiereUtilisation:
            return "Quantité détériorée";
        case AnomalieType.ColisAbime:
            return "Quantité abîmée";
        case AnomalieType.DemandeRetour:
        case AnomalieType.DemandeRetourVolontaire:
            return "Quantité à retourner";
        case AnomalieType.ClientPasRetirerMarchandise:
            return "Quantité reprise";
        default:
            return "Quantité anomalie";
    }
}


class LigneGestionQualification extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            order: 'asc',
            orderBy: 'numeroLigne'
        };
    }

    handleStartEditing = (event, numeroLigne) => {
        const { onStartEditing } = this.props;

        onStartEditing(event, numeroLigne);
    }

    handleRequestSort(event, property, type) {
        const { pieceGestionLignes } = this.props;
        const { orderBy, order } = this.state;

        // On détermine le nouveau tri.
        let newOrderBy = property;
        let newOrder = 'asc';
        if (orderBy === property && order === 'asc') {
            newOrder = 'desc';
        }

        // On effectue le nouveau tri.
        let data = pieceGestionLignes;

        if (type === 'chaine') {
            data = newOrder === 'desc'
                ? pieceGestionLignes.sort((a, b) => (a[newOrderBy] === null && b[newOrderBy] === null ? 0 : a[newOrderBy] === null ? 1 : b[newOrderBy] === null ? -1 : b[newOrderBy].localeCompare(a[newOrderBy])))
                : pieceGestionLignes.sort((a, b) => (a[newOrderBy] === null && b[newOrderBy] === null ? 0 : a[newOrderBy] === null ? 1 : b[newOrderBy] === null ? -1 : a[newOrderBy].localeCompare(b[newOrderBy])));
        }

        if (type === 'entier') {
            data = newOrder === 'desc'
                ? pieceGestionLignes.sort((a, b) => (b[newOrderBy] < a[newOrderBy] ? -1 : 1))
                : pieceGestionLignes.sort((a, b) => (a[newOrderBy] < b[newOrderBy] ? -1 : 1));
        }

        // On enregistre le nouveau tri dans le state.
        this.setState({ data, order: newOrder, orderBy: newOrderBy });
    }

    renderRows() {
        const {
            classes,
            pieceGestionLignes,
            typeAnomalie,
            disabled,
            disableCompose,
            disableNegative,
            disableZero,
            reclamation,
            afficherQuantiteRetournable,
            capperSaisie,
        } = this.props;

        const colonnesQuantites = afficherQuantiteRetournable;

        const { data, order, orderBy } = this.state;

        let list = pieceGestionLignes;
        if (data) {
            list = data;
        }

        const colonnePiecesLivraison = colonnesQuantites && list.some(l => l.piecesLivraison && l.piecesLivraison.length > 0);

        const colonneFournisseur = colonnesQuantites
            && typeAnomalie !== AnomalieType.DefautProduitPremiereUtilisation
            && list.some(l => l.fournisseur);

        const colonneCommentaire = reclamation.lignes.some(l => l.commentaireAnomalie && l.commentaireAnomalie.trim() !== '');
        const colonneDescriptif = lstTypeAnomalieAfficherDescriptif.includes(typeAnomalie);

        return (
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell
                            key='numLigne'
                            className={classes.colNumeroLigne}
                        >
                            <Tooltip
                                title='Trier'
                                placement='bottom-start'
                                enterDelay={300}>
                                <TableSortLabel active={orderBy === 'numeroLigne'}
                                    direction={order}
                                    onClick={event => this.handleRequestSort(event, 'numeroLigne', 'entier')}
                                >
                                    Numéro ligne
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>
                        <TableCell
                            key='codeArticle'
                            className={classes.colCodeArticle}
                        >
                            <Tooltip
                                title="Trier"
                                placement="bottom-start"
                                enterDelay={300}
                            >
                                <TableSortLabel active={orderBy === 'codeArticle'}
                                    direction={order}
                                    onClick={event => this.handleRequestSort(event, 'codeArticle', 'chaine')}
                                >
                                    Code article
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>
                        <TableCell>Désignation article</TableCell>

                        {(typeAnomalie === AnomalieType.DefautProduitPremiereUtilisation) && (
                            <React.Fragment>
                                <TableCell className={classes.colMarqueExclusive}>Marque exclusive</TableCell>
                                <TableCell className={classes.colFournisseur}>Fournisseur</TableCell>
                            </React.Fragment>
                        )}

                        {colonneFournisseur && (
                            <TableCell>Fournisseur</TableCell>
                        )}
                        {colonnePiecesLivraison && (
                            <TableCell>Pièce(s) livraison</TableCell>
                        )}

                        {(typeAnomalie !== AnomalieType.DemandeRetour && typeAnomalie !== AnomalieType.DemandeRetourVolontaire) && (
                            <React.Fragment>
                                <TableCell className={classes.colQuantite}>Quantité</TableCell>
                                {colonnesQuantites && (
                                    <React.Fragment>
                                        <TableCell className={classes.colQuantite}>Quantité livrée</TableCell>
                                        <TableCell className={classes.colQuantite}>Quantité dossier en cours</TableCell>
                                        <TableCell className={classes.colQuantite}>Quantité retournable</TableCell>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                        {(typeAnomalie === AnomalieType.DemandeRetour || typeAnomalie === AnomalieType.DemandeRetourVolontaire) && (
                            <React.Fragment>
                                <TableCell className={classes.colQuantite}>Quantité commandée</TableCell>
                                {colonnesQuantites && (
                                    <React.Fragment>
                                        <TableCell className={classes.colQuantite}>Quantité livrée</TableCell>
                                        <TableCell className={classes.colQuantite}>Quantité dossier en cours</TableCell>
                                        <TableCell className={classes.colQuantite}>Quantité retournable</TableCell>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}

                        <TableCell className={classes.colPrix}>Prix unitaire</TableCell>

                        <TableCell className={classes.colQuantite}>{getLibelleQuantiteAnomalie(typeAnomalie)}</TableCell>

                        {colonneDescriptif && (
                            <TableCell>{getLibelleDescriptif(typeAnomalie)}</TableCell>
                        )}

                        {colonneCommentaire && (
                            <TableCell>Commentaire</TableCell>
                        )}

                        {(typeAnomalie === AnomalieType.DemandeRetour || typeAnomalie === AnomalieType.DemandeRetourVolontaire) && (
                            <TableCell />
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.map(l => {
                        const ligneAnomalie = this.ligneAnomalie(l.numeroLigne);

                        let autoriseClick = !disabled;
                        let title = null;

                        if (autoriseClick) {
                            if (disableCompose && l.kitType === KitType.Compose) {
                                autoriseClick = false;
                                title = "saisie autorisée uniquement sur les composants";
                            }
                            else if (disableNegative && l.quantite < 0) {
                                autoriseClick = false;
                                title = "La saisie d'un dossier après-vente sur une quantité négative n'est pas autorisée";
                            }
                            else if (disableZero && l.quantite === 0) {
                                autoriseClick = false;
                                title = "La saisie d'un dossier après-vente sur une quantité à 0 n'est pas autorisée";
                            }
                            else if (typeAnomalie === AnomalieType.DemandeRetourVolontaire || typeAnomalie === AnomalieType.DemandeRetour) {
                                if (l.retourExclusionFlag > 0) {
                                    autoriseClick = false;

                                    const retourExcluType = retourExclusionErreurMessages.find(x => (x.exclusionFlag & l.retourExclusionFlag) === x.exclusionFlag);
                                    title = retourExcluType.message;
                                }
                            }
                            else if (typeAnomalie === AnomalieType.DefautProduitPremiereUtilisation && !l.fournisseur) {
                                autoriseClick = false;
                                title = "Fournisseur inconnu sur cette ligne, qualification SAV impossible — contacter le support";
                            }

                            if (autoriseClick && capperSaisie && l.quantiteRetournable <= 0) {
                                autoriseClick = false;
                                title = "Aucune quantité retournable sur cette ligne.";
                            }
                        }

                        return (
                            <TooltipOnCursor
                                key={l.numeroLigne}
                                title={title}
                            >
                                <TableRow
                                    hover
                                    onClick={autoriseClick ? event => this.handleStartEditing(event, l.numeroLigne) : null}
                                    className={ligneAnomalie && l.quantite > 0 ? classes.rowAnomalie : !autoriseClick ? classes.rowStriped : undefined}
                                >
                                    <TableCell className={classes.colNumeroLigneBody}>{l.numeroLigne}</TableCell>
                                    <TableCell className={classes.colCodeArticle}>{l.codeArticle}</TableCell>
                                    <TableCell className={classes.wrapCell}>{l.designationArticle}</TableCell>

                                    {(typeAnomalie === AnomalieType.DefautProduitPremiereUtilisation) && (
                                        <React.Fragment>
                                            <TableCell className={classes.colMarqueExclusive}>{l.marqueExclusive ? 'Oui' : 'Non'}</TableCell>
                                            <TableCell className={classes.colFournisseur}>
                                                {l.fournisseur
                                                    ? <>{l.fournisseur.nom}{l.fournisseur.autoriseSAVPlateformeLogistique ? ' *' : ''}</>
                                                    : <Chip label="Inconnu" color="error" size="small" />}
                                            </TableCell>
                                        </React.Fragment>
                                    )}

                                    {colonneFournisseur && (
                                        <TableCell className={classes.ellipsisCell}>{l.fournisseur ? (l.fournisseur.nom || l.fournisseur.code || '') : ''}</TableCell>
                                    )}
                                    {colonnePiecesLivraison && (
                                        <TableCell>
                                            {l.piecesLivraison && l.piecesLivraison.length > 0
                                                ? l.piecesLivraison.map(p => <div key={p}>{p}</div>)
                                                : '--'}
                                        </TableCell>
                                    )}

                                    <TableCell className={classes.colQuantite}>{l.quantite}</TableCell>

                                    {colonnesQuantites && (
                                        <React.Fragment>
                                            <TableCell className={classes.colQuantite}>{l.quantiteLivree}</TableCell>
                                            <TableCell className={classes.colQuantite}>{l.quantiteEnCoursDossier}</TableCell>
                                            <TableCell className={classes.colQuantite}>{l.quantiteRetournable}</TableCell>
                                        </React.Fragment>
                                    )}

                                    <TableCell className={classes.colPrix}>{l.prixUnitaire.toFixed(2) + ' €'}</TableCell>

                                    <TableCell className={classes.colQuantite}>{reclamation.lignes.find(x => x.numeroLigne === l.numeroLigne)?.quantiteAnomalie}</TableCell>

                                    {colonneDescriptif && (
                                        <TableCell className={classes.ellipsisCell}>{reclamation.lignes.find(x => x.numeroLigne === l.numeroLigne)?.descriptifAnomalie}</TableCell>
                                    )}

                                    {colonneCommentaire && (
                                        <TableCell className={classes.ellipsisCell}>{reclamation.lignes.find(x => x.numeroLigne === l.numeroLigne)?.commentaireAnomalie}</TableCell>
                                    )}

                                    {(typeAnomalie === AnomalieType.DemandeRetour || typeAnomalie === AnomalieType.DemandeRetourVolontaire) && (
                                        <TableCell sx={{ padding: '14px' }}>
                                            {l.perissable && (
                                                <Chip label="Périssable" color="error" size="small" />
                                            )}
                                            {l.erreurKit && (
                                                <Chip label="Anomalie Code fantôme" color="error" size="small" />
                                            )}
                                        </TableCell>
                                    )}

                                </TableRow>
                            </TooltipOnCursor>
                        );
                    })}
                </TableBody>
            </Table>
        );
    }

    renderEditing(row) {
        const { reclamation, typeAnomalie, ligneQualification, onChange, onChangeQuantiteAnomalie, onCancelEditing,
            onDoneEditing, onDeleteEditing, quantiteLibre, afficherQuantiteRetournable, capperSaisie } = this.props;


        return (
            <LigneEditee
                row={row}
                reclamation={reclamation}
                typeAnomalie={typeAnomalie}
                ligneQualification={ligneQualification}
                onChange={onChange}
                onChangeQuantiteAnomalie={onChangeQuantiteAnomalie}
                onCancelEditing={onCancelEditing}
                onDoneEditing={onDoneEditing}
                onDeleteEditing={onDeleteEditing}
                quantiteLibre={quantiteLibre}
                afficherQuantiteRetournable={afficherQuantiteRetournable}
                capperSaisie={capperSaisie}
            />);

    }

    renderRowsOrEditing() {
        const { editedRowNumber, pieceGestionLignes } = this.props;

        let row = pieceGestionLignes.find(l => l.numeroLigne === editedRowNumber);

        if (!row) {
            return this.renderRows();
        } else {
            return this.renderEditing(row);
        }
    }

    ligneAnomalie = (numeroLigne) => {
        const { reclamation } = this.props;

        return reclamation.lignes.find(l => l.numeroLigne === numeroLigne);
    }

    render() {
        const { classes } = this.props;

        return (
            <Paper className={classes.rootTable}>
                {this.renderRowsOrEditing()}
            </Paper>
        );
    }
}

LigneGestionQualification.propTypes = {
    reclamation: PropTypes.object.isRequired,
    ligneQualification: PropTypes.object.isRequired,
    pieceGestionLignes: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeQuantiteAnomalie: PropTypes.func.isRequired,
    typeAnomalie: PropTypes.number.isRequired,
    editedRowNumber: PropTypes.number.isRequired,
    onStartEditing: PropTypes.func.isRequired,
    onCancelEditing: PropTypes.func.isRequired,
    onDeleteEditing: PropTypes.func.isRequired,
    onDoneEditing: PropTypes.func.isRequired,
    disableCompose: PropTypes.bool,
};

LigneGestionQualification.defaultProps = {
    disableCompose: false,
    disableNegative: true,
    disableZero: true
};

export default withStyles(styles)(LigneGestionQualification);
